import { CommandBar } from "@fluentui/react";
import { Badge, Button, Descriptions, Divider, Drawer, Skeleton } from "antd";
import NaocDailyProductionStore from "../../store/naocdailyproductionstore";
import { observer } from "mobx-react-lite";
import React, { createContext, useContext } from "react";
import { Printer } from "react-feather";
import RequestStore from "../store/requeststore";
import moment from "moment";
import formatNumber from "accounting-js/lib/formatNumber";
import renderHTML from "react-render-html";
import { Printd } from 'printd'
const requestStoreCtx = createContext(RequestStore);
export const NaocDailyProductionDetail = observer(() => {
  const naocDailyProductionStore = useContext(NaocDailyProductionStore);
  const requestStore = useContext(requestStoreCtx);
  return (
    <Drawer
      title={`Naoc Daily Production Details`}
      placement="right"
      width={"60%"}
      closable={true}
      destroyOnClose={true}
      onClose={() => {
        requestStore.showNaocProductionDetailDialog = false;
      }}
      visible={requestStore.showNaocProductionDetailDialog}
    >
      {naocDailyProductionStore.isLoadingDailyProd ? (
        <>
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
        </>
      ) : (
        <>
        <div id="printPane">
          <Badge.Ribbon
            text={naocDailyProductionStore.initFormaData.status}
            placement="start"
            color={
              naocDailyProductionStore.initFormaData.approvalStatus === 1
                ? "gold"
                : naocDailyProductionStore.initFormaData.approvalStatus === 2
                ? "#87d068"
                : naocDailyProductionStore.initFormaData.approvalStatus === 3
                ? "#f50"
                : "#d9d9d9"
            }
          >
            <CommandBar
              farItems={[
                {
                  key: "print",
                  text: "Print",
                  onRenderIcon: () => <Printer className="qicon" />,
                  onClick:()=>{
                    const d=new Printd();
                    d.print( document.getElementById('printPane'), [] )
                  }
                },
              ]}
            />
          </Badge.Ribbon>
          <Divider>{`${
            naocDailyProductionStore.IsEquityProduction === 0
              ? "NAOC JV GROSS"
              : "NAOC EQUITY SHARE"
          } PRODUCTION AND EVACUATIONS @ ${moment(
            naocDailyProductionStore.initFormaData.productionDate
          ).format(" dddd, Do MMMM YYYY")}`}</Divider>
          <Descriptions
            title={
              <div style={{ color: "red", paddingTop: "5px" }}>
                OIL PRODUCTION (bopd)
              </div>
            }
            size={"small"}
            bordered
            labelStyle={{ fontWeight: "bold" }}
          >
            <Descriptions.Item label="Land Area Metered/Adjusted">
              {formatNumber(
                naocDailyProductionStore.initFormaData.landAreaOil,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Swamp Area Metered/Adjusted">
              {formatNumber(
                naocDailyProductionStore.initFormaData.swampAreaOil,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
            <Descriptions.Item label="BENIBOYE Daily Metered">
              {formatNumber(
                naocDailyProductionStore.initFormaData.beniboyeOilDailyMetered,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>

            <Descriptions.Item label="Total Metered/Adjusted Prod">
              {formatNumber(
                naocDailyProductionStore.initFormaData.totalOilMeteredProd,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Total NAOC JV Oil Produced/Evacuated">
              <span style={{ color: "red", fontWeight: "bold" }}>
                {formatNumber(
                  naocDailyProductionStore.initFormaData.totalOilProduced,
                  {
                    precision: 2,
                    thousand: ",",
                  }
                )}
              </span>
            </Descriptions.Item>
          </Descriptions>
          <Descriptions
            title={
              <div style={{ color: "green", paddingTop: "5px" }}>
                GAS PRODUCTION (mscf/d)
              </div>
            }
            size={"small"}
            bordered
            labelStyle={{ fontWeight: "bold" }}
          >
            <Descriptions.Item label="Land Area Gas Produced">
              {formatNumber(
                naocDailyProductionStore.initFormaData.landAreaGas,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Swamp Area Gas Produced">
              {formatNumber(
                naocDailyProductionStore.initFormaData.swampAreaGas,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Total Gas Produced">
              <span style={{ color: "green", fontWeight: "bold" }}>
                {formatNumber(naocDailyProductionStore.totalGasProduced, {
                  precision: 2,
                  thousand: ",",
                })}
              </span>
            </Descriptions.Item>
          </Descriptions>
          <Descriptions
            title={
              <div style={{ color: "#22543D" }}>GAS UTILIZATION (mscf/d)</div>
            }
            size={"small"}
            bordered
            labelStyle={{ fontWeight: "bold" }}
          >
            <Descriptions.Item label="Total Gas Flared">
              {formatNumber(
                naocDailyProductionStore.initFormaData.totalGasFlared,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Total Gas Internally Utilized">
              {formatNumber(
                naocDailyProductionStore.initFormaData
                  .totalGasInternallyUtilized,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Gas Utilized for NGL">
              {formatNumber(
                naocDailyProductionStore.initFormaData
                  .gasInternallyUtilizedforNGL,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
          </Descriptions>
          <Descriptions
            title={
              <div style={{ color: "#48BB78" }}>GAS EVACUATION (mscf/d)</div>
            }
            size={"small"}
            bordered
            labelStyle={{ fontWeight: "bold" }}
          >
            <Descriptions.Item label="Daily FuelGas To EPCL.">
              {formatNumber(
                naocDailyProductionStore.initFormaData.dailyFuelGasToEPCL,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Daily Gas Delivery to RS IPP">
              {formatNumber(
                naocDailyProductionStore.initFormaData.dailyGasDeliveryToRSIPP,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Daily Gas Delivery to BONNY">
              {formatNumber(
                naocDailyProductionStore.initFormaData.dailyGasDeliveryToBonny,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Daily Gas Delivery to JV IPP">
              {formatNumber(
                naocDailyProductionStore.initFormaData.dailyGasJVIPP,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Daily Gas To EPCL FERT PLT">
              {formatNumber(
                naocDailyProductionStore.initFormaData.dailyGasEPCLFertPLT,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Total Gas Evacuated">
              <span style={{ color: "#1890ff", fontWeight: "bold" }}>
                {formatNumber(naocDailyProductionStore.totalGasEvacuated, {
                  precision: 2,
                  thousand: ",",
                })}
              </span>
            </Descriptions.Item>
          </Descriptions>
          <Descriptions
            title={
              <div style={{ color: "#68D391" }}>
                GAS INJECTION / LIFT (mscf/d)
              </div>
            }
            size={"small"}
            bordered
            labelStyle={{ fontWeight: "bold" }}
          >
            <Descriptions.Item label="OB/OB G/Plant Gas Inj./Lift">
              {formatNumber(naocDailyProductionStore.initFormaData.obGpGasInj, {
                precision: 2,
                thousand: ",",
              })}
            </Descriptions.Item>
            <Descriptions.Item label="Kwale G/Plant Gas Inj./Lift">
              {formatNumber(
                naocDailyProductionStore.initFormaData.kwaleGpGasInj,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Akri Gas To Oguta Plant">
              {formatNumber(
                naocDailyProductionStore.initFormaData.akriGasToOGutaPlant,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Gas Inj.Into Akri 2 at Oguta">
              {formatNumber(
                naocDailyProductionStore.initFormaData.akriGasInjToOGutaPlant,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
          </Descriptions>
          <Descriptions
            title={<div style={{ color: "#2F855A" }}>GAS METERS (mscf/d)</div>}
            size={"small"}
            bordered
            labelStyle={{ fontWeight: "bold" }}
          >
            <Descriptions.Item label="Total Gas Rec. at OB/OB G/Plant">
              {formatNumber(
                naocDailyProductionStore.initFormaData.totalGasRecOBGp,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Total Gas Rec. at Kwale G/Plant">
              {formatNumber(
                naocDailyProductionStore.initFormaData.totalGasRecKwaleGp,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
          </Descriptions>
          <Descriptions
            title="PRODUCTION UPTIME"
            size={"small"}
            bordered
            labelStyle={{ fontWeight: "bold" }}
          >
            <Descriptions.Item label="MTD Uptime">
              {naocDailyProductionStore.initFormaData.mtdUptime}
            </Descriptions.Item>
            <Descriptions.Item label="YTD Uptime">
              {naocDailyProductionStore.initFormaData.ytdUptime}
            </Descriptions.Item>
          </Descriptions>
          <Descriptions
            title={<div style={{ color: "#D69E2E" }}>NGL (bopd)</div>}
            size={"small"}
            bordered
            labelStyle={{ fontWeight: "bold" }}
          >
            <Descriptions.Item label="NGL Produced">
              {formatNumber(
                naocDailyProductionStore.initFormaData.nglProduced,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
            <Descriptions.Item label="NGL Delivered">
              {formatNumber(
                naocDailyProductionStore.initFormaData.nglDelivered,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
          </Descriptions>

          <Descriptions
            title="PRODUCTION UNITIZATIONS"
            size={"small"}
            bordered
            labelStyle={{ fontWeight: "bold" }}
          >
            <Descriptions.Item label="SPDC Akri/Oguta Share">
              {formatNumber(
                naocDailyProductionStore.initFormaData.spdcAkriOguta,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
            <Descriptions.Item label="SPDC Ogbain/Afuo Share">
              {formatNumber(
                naocDailyProductionStore.initFormaData.spdcOgbainAfuo,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>

            <Descriptions.Item label="Spdc Samabri/Biseni Share">
              {formatNumber(
                naocDailyProductionStore.initFormaData.spdcSamabiriBiseni,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Spdc Tebidaba Unitized Share">
              {formatNumber(
                naocDailyProductionStore.initFormaData.spdcTebidaba,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Spdc Oshie Share">
              {formatNumber(naocDailyProductionStore.initFormaData.spdcOshie, {
                precision: 2,
                thousand: ",",
              })}
            </Descriptions.Item>
            <Descriptions.Item label="Spdc Total Unitized Share">
              <span style={{ color: "#1890ff", fontWeight: "bold" }}>
                {formatNumber(naocDailyProductionStore.totalSpdcUnitizedShare, {
                  precision: 2,
                  thousand: ",",
                })}
              </span>
            </Descriptions.Item>

            <Descriptions.Item label="Pillar/Newton Unitized Share">
              {formatNumber(
                naocDailyProductionStore.initFormaData.pillarNewton,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Total Unitized Share">
              <span style={{ color: "#1890ff", fontWeight: "bold" }}>
                {formatNumber(naocDailyProductionStore.totalUnitizedShare, {
                  precision: 2,
                  thousand: ",",
                })}
              </span>
            </Descriptions.Item>
          </Descriptions>
          <Descriptions
            title="PRODUCTION REMARKS"
            size={"small"}
            bordered
            labelStyle={{ fontWeight: "bold" }}
          >
            <Descriptions.Item label="LAND AREA  PRODUCTION REMARKS">
              {naocDailyProductionStore.initFormaData.landAreaRemarks &&
                renderHTML(
                  naocDailyProductionStore.initFormaData.landAreaRemarks
                )}
            </Descriptions.Item>
            <Descriptions.Item label="SWAMP AREA  PRODUCTION REMARKS">
              {naocDailyProductionStore.initFormaData.swampAreaRemarks &&
                renderHTML(
                  naocDailyProductionStore.initFormaData.swampAreaRemarks
                )}
            </Descriptions.Item>
          </Descriptions>

          {naocDailyProductionStore.initFormaData.approvalStatus === 2 && (
            <Descriptions
              title="PRODUCTION APPROVAL "
              size={"small"}
              bordered
              labelStyle={{ fontWeight: "bold" }}
            >
              <Descriptions.Item label="Approved On">
                {moment(
                  naocDailyProductionStore.initFormaData.approvedDate
                ).format("LLLL")}
              </Descriptions.Item>
              <Descriptions.Item label="Approver">
                {naocDailyProductionStore.initFormaData.approver}
              </Descriptions.Item>
              <Descriptions.Item label="Approver Remarks">
                {naocDailyProductionStore.initFormaData.approverComment}
              </Descriptions.Item>
            </Descriptions>
          )}
          </div>
        </>
      )}
    </Drawer>
  );
});

